module.exports = __webpack_public_path__ + "app/img/cartouche_moto_meca.703e4d0b.jpg";